import React from 'react'

const AppFilePlaceholderIcon = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="96" height="96" rx="16" fill="url(#paint0_linear_14098_1815)" />
      <path
        d="M39.875 51.125L44.1742 46.8258C44.9064 46.0936 46.0936 46.0936 46.8258 46.8258L51.125 51.125M49.875 49.875L51.0492 48.7008C51.7814 47.9686 52.9686 47.9686 53.7008 48.7008L56.125 51.125M41.125 54.25H54.875C55.5654 54.25 56.125 53.6904 56.125 53V43C56.125 42.3096 55.5654 41.75 54.875 41.75H41.125C40.4346 41.75 39.875 42.3096 39.875 43V53C39.875 53.6904 40.4346 54.25 41.125 54.25ZM49.875 44.875H49.8813V44.8813H49.875V44.875ZM50.1875 44.875C50.1875 45.0476 50.0476 45.1875 49.875 45.1875C49.7024 45.1875 49.5625 45.0476 49.5625 44.875C49.5625 44.7024 49.7024 44.5625 49.875 44.5625C50.0476 44.5625 50.1875 44.7024 50.1875 44.875Z"
        stroke="#5E5E5E"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14098_1815"
          x1="48"
          y1="0"
          x2="48"
          y2="96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F5F5F5" />
          <stop offset="1" stop-color="#ECECEC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AppFilePlaceholderIcon
